import type { Tema } from '@/types/tema.types';

/**
 * Chave da preferência de tema.
 *
 * O mesmo literal aparece no script inline do `index.html`, que roda antes de qualquer
 * módulo carregar para o tema não piscar na primeira pintura. É duplicação consciente —
 * não há como o script pré-bundle importar daqui. Ao mudar um, mudar o outro.
 */
export const CHAVE_TEMA = 'nicon-status:tema';

/**
 * Claro é o padrão, independente da preferência do sistema.
 *
 * Uma página de status é lida por quem chegou de um link, muitas vezes num aparelho que
 * não é o de trabalho. Vale mais ela ser sempre a mesma coisa do que adivinhar.
 */
export const TEMA_PADRAO: Tema = 'claro';

/** Cor da barra do navegador em cada tema — mantém os valores originais do design. */
export const COR_NAVEGADOR: Record<Tema, string> = {
  claro: '#166ac7',
  escuro: '#1c1c1c',
};

export const ROTULO_ALTERNAR_TEMA: Record<Tema, string> = {
  claro: 'Mudar para o tema escuro',
  escuro: 'Mudar para o tema claro',
};
